import styled, { css } from 'styled-components';

export const placeholder = rules => css`
  &::-webkit-input-placeholder {
    ${rules}
  }

  &:-moz-placeholder {
    ${rules}
  }

  &::-moz-placeholder {
    ${rules}
  }

  &:-ms-input-placeholder {
    ${rules}
  }
`;

export const contentCentered = css`
  text-align: center;
  white-space: nowrap;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -ms-user-select: none;

  & > * {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    white-space: normal;
    -moz-user-select: text;
    -webkit-user-select: text;
    -ms-user-select: text;
  }

  &:before {
    content: '';
    height: 100%;
    margin: 0 -0.1em;
    display: inline-block;
    vertical-align: middle;
    -moz-user-select: -moz-none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

export const absFull = (t = 0, r = 0, b = 0, l = 0) => css`
  position: absolute;
  top: ${t};
  right: ${r};
  bottom: ${b};
  left: ${l};
`;

export const textLabel = () => css`
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const LeftContainer = styled.div`
  ${absFull('auto', 0, 0, 0)};
  width: ${({ width }) => width};
`;

export const RightContainer = styled.div`
  ${absFull('auto', 0, 0, 'auto')};
  width: ${({ width }) => width};
`;

export const truncateByWidth = width => (`
  width: ${width};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`);

export const textOverflow = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
